import React from 'react'
import DataGrid, {
  ColumnChooser,
  FilterPanel,
  FilterRow,
  HeaderFilter,
  Export,
  Selection,
  SearchPanel,
  Editing,
  Column,
  Button,
  LoadPanel,
  Pager,
  Paging,
  Grouping
} from "devextreme-react/data-grid";
import { useNavigate } from 'react-router-dom';
import { Row } from 'devextreme-react/responsive-box';

export const LVGridCabeceraReporte = (props) => {
  let { dataSource, id, keyExpr, urlEdicion, AnchoBotonera, children, onRowDblClick, height,
    width, selectionMode = "multiple", PageSize = 15 } = props;
  const navigate = useNavigate();

  const onClickEdit = (e) => {

    const Item = { ...e.row.data };
    navigate(urlEdicion + "/" + Item.Codigo)
  };

  const onClickClone = (e) => {

    const Item = { ...e.row.data };
  };

  return (
    <DataGrid
      dataSource={dataSource}
      style={{ fontSize: '11px', fontFamily: 'Tahoma, sans-serif' }}
      showRowLines={true}
      width={width}
      showBorders={true}
      allowColumnResizing={true}
      onRowDblClick={onRowDblClick}
      height={height}
      id={id}
      keyExpr={keyExpr}
      rowAlternationEnabled={true}
      urlEdicion={urlEdicion}
    >
      <HeaderFilter visible={true} />
      <FilterPanel visible={true} />
      <FilterRow visible={true} />
      <Selection mode={selectionMode} />
      <Export enabled={true} allowExportSelectedData={true} />
      <SearchPanel visible={true} />
      <LoadPanel enabled={true} />

      <ColumnChooser enabled="True" mode="select" />
      <Grouping autoExpandAll={false} />
      <Editing
        mode="popup"
        useIcons={true}
        allowAdding={false}
      />
      {/* <Popup title="Employee Info" showTitle={true} width={700} height={525} />   */}

      {children}

      <Paging defaultPageSize={PageSize} />
      <Pager
        showPageSizeSelector={false}
      />
    </DataGrid>
  );
}